import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';
import { socket } from '../../../../';
import { CUSTOM } from "../../../sc-utilities/snackbar/store/actionTypes";
import * as snackbarActions from "../../../sc-utilities/snackbar/store/snackbarActions";
import snackbarStore from "../../../../snackbarStore";
// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'control-machine',
    pluginName: 'CONTROL_MACHINE',
    entityName: 'CONTROL_MACHINE',
    fetchSuccessMessage: '',
    loadSuccessMessage: '',
    createFailedUseBackendMessage: true,
    createSuccessUseBackendMessage: true,
    deleteFailedUseBackendMessage: true,
    editFailedUseBackendMessage: true,
    bulkDeleteFailedUseBackendMessage: true


});

// Fetch control-machine action creators
export const fetchControlMachineInit = () => {
    return crudActions.fetchInit();
};
export const fetchControlMachineStart = () => {
    return crudActions.fetchStart();
};
export const fetchControlMachineSuccess = (count, list) => {
    return crudActions.fetchSuccess(count, list);
};
export const fetchControlMachineFail = () => {
    return crudActions.fetchFail();
};





export const fetchControlMachinesCount = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        dispatch(fetchControlMachineInit());
        try {
            let countRes = await rest.post("/control-machine/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchControlMachineSuccess(0, []));
                }
                return countRes.data.result.data
            }
            dispatch(fetchControlMachineFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch control machine data."}`,
                options: {
                    variant: 'warning'
                }
            });
            return 0;
        } catch (error) {
            dispatch(fetchControlMachineFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch control machine data."}`,
                options: {
                    variant: 'error'
                }
            });
            return 0;
        }
    }
}

export const fetchControlMachines = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        dispatch(fetchControlMachineInit());
        try {
            let listRes = await rest.post("/control-machine/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchControlMachineFail(filterData.count, listRes.data.result.data));
                return listRes.data.result.data
            }
            dispatch(fetchControlMachineSuccess());
            return []

        } catch (error) {
            dispatch(fetchControlMachineFail());
            return []

        }
    }
}


// Bulk delete control machine
export const bulkDeleteControlMachinesInit = () => {
    return crudActions.bulkDeleteInit()
};
export const bulkDeleteControlMachinesStart = () => {
    return crudActions.bulkDeleteStart();
};
export const bulkDeleteControlMachinesSuccess = result => {
    return crudActions.bulkDeleteSuccess(result);
};
export const bulkDeleteControlMachinesFail = error => {
    return crudActions.bulkDeleteFail(error);
};

export const bulkDeleteControlMachines = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(bulkDeleteControlMachinesStart());
        try {
            let res = await rest.post('/control-machine/bulk-delete', params);
            if (res.data && res.data.succeeded) {
                dispatch(bulkDeleteControlMachinesSuccess(res.data.result.data));
                snackActions.snackBar({
                    message: `Successfully deleted control machine.`,
                    options: {
                        variant: 'success'
                    }
                });
                return
            }
            dispatch(bulkDeleteControlMachinesFail({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete control machine."}`,
            }))
            snackActions.snackBar({
                message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot bulk delete control machine."}`,
                options: {
                    variant: 'warning'
                }
            });
            return null;
        } catch (error) {
            dispatch(bulkDeleteControlMachinesFail(error));
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    };
}

// Load control machine action creators
export const loadControlMachineInit = () => { return crudActions.loadInit() };
export const loadControlMachineStart = () => { return crudActions.loadStart(); };
export const loadControlMachineSuccess = loadedControlMachine => { return crudActions.loadSuccess(loadedControlMachine); };
export const loadControlMachineFail = error => { return crudActions.loadFail(error); };
export const loadControlMachine = (loadParams, options = {}) => {
    return async dispatch => {
        await crudActions.load(dispatch, loadParams, options);
    };
};


// Edit action creators
export const editControlMachineInit = () => {
    return crudActions.editInit();
};
export const editControlMachineStart = () => {
    return crudActions.editStart();
};
export const editControlMachineSuccess = editedControlMachine => {
    return crudActions.editSuccess(editedControlMachine);
};
export const editControlMachineFail = error => {
    return crudActions.editFail(error);
};
export const editControlMachine = data => {
    return async dispatch => {
        await crudActions.edit(dispatch, data);
    };
};

export const importProducts = data => {
    const rest = getAxiosInstance();
    data.append('SocketID', socket.id.split('#')[1]);
    return async dispatch => {
        try {
            let res = await rest.post('control-machine/import-command-products', data);
            if (res.data.status === 200) {
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })
                socket.on('command-products', async msg => {
                    const { Generated, ToGenerate, Message, Status } = msg;
                    snackbarStore.dispatch(snackbarActions.showCollection({ type: CUSTOM, collection: { Generated, ToGenerate } }));
                    if (Status === 'error') {
                        socket.off('command-products');
                        snackbarStore.dispatch(snackbarActions.hideCollection({ type: CUSTOM, collection: { Generated, ToGenerate } }));
                        return snackActions.snackBar({
                            message: Message || `Error: Command product import failed. Please contact administrator.`,
                            options: {
                                variant: 'error'
                            }
                        });
                    }

                    if (Status === 'generated') {
                        socket.off('command-products');
                        snackbarStore.dispatch(snackbarActions.hideCollection({ type: CUSTOM, collection: { Generated, ToGenerate } }));
                        snackActions.snackBar({
                            message: `Command import finished.`,
                            options: {
                                variant: 'success'
                            }
                        });
                    }
                })
                return res.data.status === 200;
            }
            else {

                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot upload command data."}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    }
}

export const revokeControlMachine = (data) => {
    const rest = getAxiosInstance();

    return async dispatch => {
        try {
            const res = await rest.post("/control-machine/revoke", data);
            if (res.data.status === 200) {
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })

                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot revoke control machine."}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    }
}

export const createControlMachine = (data) => {
    const rest = getAxiosInstance();

    return async dispatch => {
        try {
            const res = await rest.post("/control-machine/create-offline", data);
            if (res.data.status === 200) {
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: 'success'
                    }
                })

                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot create control machine."}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    }
};

export const exportOfflineLicenses = (data) => {
    const rest = getAxiosInstance();

    return async dispatch => {
        try {
            const res = await rest.post("/license-vault/create", data);
            if (res.status === 200) {
                snackActions.snackBar({
                    message: `${res?.data?.message ?? "License vault created."}`,
                    options: {
                        variant: 'success'
                    }
                })

                return res.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot export licenses."}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return false;
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return false;
        }
    }
}